<template>
	<v-card>

		<v-card-title class="justify-center">
			<h1 class="text-center">הרכישה בוצעה בהצלחה!</h1>
		</v-card-title>
		<v-card-text class="display-2 mb-4"> {{thanks}}</v-card-text>
		<v-toolbar color="success">
			<v-toolbar-title>מספרי הכרטיסים</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-list
			>
				<v-list-item
					v-for="card in cards"
					:key="card.id"
				>
					<v-list-item-content>
						<v-list-item-title>{{ card.number }}</v-list-item-title>
					</v-list-item-content>

					<v-list-item-action>
						<v-btn icon>
							<v-icon color="grey lighten-1">mdi-tag</v-icon>
						</v-btn>
					</v-list-item-action>
				</v-list-item>

				<v-divider inset></v-divider>

			</v-list>
		</v-card-text>

	</v-card>

</template>

<script>
	export default {
		name: "card-list",
		props:{thanks:String},
		computed: {
			cards() {
				return this.$store.state.CardModule.cards;
			}
		}
	};
</script>

<style scoped>

</style>
